import { ReactNode, useEffect, useState } from 'react';
import APP from 'stores/APP';
import classlist from 'utils/classlist';
import './style.scss';

const BottomBox: React.FC<{
    className?: string;
    children: ReactNode;
}> = ({ children, className = '' }) => {
    const [activeBtnFixed, setActiveBtnFixed] = useState(true);

    useEffect(() => {
        /**
         * 安卓手机唤起软键盘时，底部吸底按钮也会被顶上去从而会遮挡住输入框的内容
         * 这里处理成和ios展示方式保持一致，当唤起换键盘时将fixed元素失效，关闭软键盘时再恢复fixed
         * 在android中软键盘弹起或收起时，会改变window的高度，因此监听window的resize事件
         */
        if (APP.isAndroid) {
            const originHeight = document.documentElement.clientHeight || document.body.clientHeight;

            const handleResize = () => {
                // 安卓唤起软键盘时，屏幕高度会减去软键盘的高度
                const resizeHeight = document.documentElement.clientHeight || document.body.clientHeight;

                if (resizeHeight < originHeight) {
                    setActiveBtnFixed(false);
                } else {
                    setActiveBtnFixed(true);
                }
            };

            window.addEventListener('resize', handleResize);

            return () => {
                window.removeEventListener('resize', handleResize);
            };
        }

        return;
    }, []);

    return <div className={classlist({ 'comp-bottom-box': activeBtnFixed }, className)}>{children}</div>;
};

export default BottomBox;
